import React, { Component } from "react";
import { Link } from "react-router-dom";
import userService from "../../Services/userService";
import { connect } from "react-redux";
import { setLoggedIn } from "../../Actions/authActions";

// Material ui
import Button from "@material-ui/core/Button";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Alert from "@material-ui/lab/Alert";
import Swal from "sweetalert2";
import "../../assets/css/login.css";
import bquickLogo from "../../assets/images/bquick-logo.png";

import {
  incorrectEmailOrPassTitle,
  userExistsInPendingListMsg,
  userExistsInPendingListTitle,
  incorrectEmailOrPassMsg,
  anotherConfEmailSend,
  subscriptionOutOfDateTitle,
  subscriptionOutOfDateMsg,
  needsConfMsg,
  resendEmailConfMsg,
  tooManyAttemptsMsg,
  generalErrMsg
} from "../../global/popupMessages";

class Login extends Component {
  state = {
    email: "",
    password: "",
    shouldRememberEmail: true,
    showConfMsg: false
  };

  constructor() {
    super();
    var emailForLogin = localStorage.getItem("emailForLogin");
    if (emailForLogin) this.state.email = emailForLogin;
  }

  render() {
    return (
      <div className="row mt-50">
        <div className="col-sm-12 center">
          <img width="150" src={bquickLogo} />
        </div>
        <div className="col-sm-3"></div>
        <div className="col-sm-6">
          <Card>
            <CardContent className="login-card">
              <h4 className="primary-color mb-40">התחבר למערכת</h4>
              <form>
                <div>
                  <TextField
                    required
                    label="אימייל"
                    className="field-strech"
                    type="email"
                    autoComplete="current-email"
                    id="email"
                    onChange={this.handleChange}
                    value={this.state.email || ""}
                  />
                </div>
                <div className="mb-40 mt-20">
                  <TextField
                    required
                    className="field-strech"
                    label="סיסמה"
                    type="password"
                    id="password"
                    onChange={this.handleChange}
                    onKeyPress={(e) => {
                      this.handleKeyPress(e.key);
                    }}
                  />
                </div>
                <div className="d-sm-flex justify-content-between align-items-center">
                  <FormGroup>
                    <FormControlLabel
                      className="remember-me-wrapper"
                      control={<Checkbox value="checkedA" color="primary" />}
                      label="זכור אותי"
                      onChange={this.toggleRememberMe}
                      checked={this.state.shouldRememberEmail}
                    />
                  </FormGroup>
                  <span className="d-inline-block">
                    <Link to="/forgot-password">לא זוכר את הסיסמה?</Link>
                  </span>
                </div>
              </form>

              <div className="mt-20">
                <Button onClick={this.handleSubmit} color="primary" variant="contained" size="small">
                  התחבר
                </Button>
              </div>
              {this.state.showConfMsg ? (
                <div className="mt-20">
                  <Alert severity="warning">
                    {needsConfMsg}
                    <br />
                    <a href="#" onClick={this.resendEmailConf}>
                      {resendEmailConfMsg}
                    </a>
                  </Alert>
                </div>
              ) : null}
              <div className="mt-20">
                אין לך משתמש עדיין? <Link to="/register">לחץ כאן ליצירת משתמש</Link>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  toggleRememberMe = (e) => {
    this.setState({ shouldRememberEmail: e.target.checked });
  };

  resendEmailConf = (e) => {
    e.preventDefault();
    if (!this.state.email) return;
    userService.resendEmailConf(this.state.email).then((data) => {
      if (data.success) {
        Swal.fire("", anotherConfEmailSend, "success");
      } else if (data.isTooManyAttempts) {
        Swal.fire("", tooManyAttemptsMsg, "warning");
      } else if (data.err) {
        Swal.fire("", generalErrMsg, "warning");
      }
    });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
      showConfMsg: false
    });
  };

  handleKeyPress = function (keyClicked) {
    if (keyClicked === "Enter") this.handleSubmit();
  };

  handleSubmit = (e) => {
    if (!this.state.password || !this.state.email) {
      Swal.fire("כל השדות הינם חובה", "האימייל והסיסמה", "warning");
      return;
    }
    userService.login(this.state.email, this.state.password).then((res) => {
      if (res["success"]) {
        var role = res["role"];
        if (role) localStorage.setItem("role", role);
        if (this.state.shouldRememberEmail) localStorage.setItem("emailForLogin", this.state.email);
        else localStorage.removeItem("emailForLogin");

        localStorage.setItem("token", res["token"]);
        localStorage.setItem("email", res["email"]);
        localStorage.setItem("isLoggedin", "true");
        this.props.setLoggedIn();

        this.props.history.push(this.isSpecialUser(role) ? "/admin/users-manager" : "/deals");
      } else if (res["needsRenewSubscription"]) {
        Swal.fire(subscriptionOutOfDateTitle, subscriptionOutOfDateMsg, "warning");
      } else if (!res["isUserFound"]) {
        Swal.fire(incorrectEmailOrPassTitle, incorrectEmailOrPassMsg, "warning");
      } else if (res["isPendingUser"]) {
        Swal.fire(userExistsInPendingListTitle, userExistsInPendingListMsg, "warning");
      } else if (!res["isEmailConfirmed"]) {
        this.setState({ showConfMsg: true });
      }
    });
  };

  isSpecialUser = function (role) {
    if (role === "admin" || role === "salesman" || role === "salesManager") return true;
    return false;
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    setLoggedIn: () => dispatch(setLoggedIn())
  };
};

export default connect(null, mapDispatchToProps)(Login);
